import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ArrowDownIcon, MoreIcon } from "../../../assets/icons/Icons";
import { useContract } from "../../../redux/contractReducer";
import { useSiniester } from "../../../redux/siniesterReducer";
import { Button } from "../../ui";
import CardMovimientos from "./CardMovimientos";
import { ModalAgregarMovimiento } from "./ModalAgregarMovimiento";
import { Modal } from "react-responsive-modal";
import { CloseBlueIcon } from "../../../assets/icons/Icons";
import { ModalRegistroPago } from "../../../components/pageComponents/CapturaSiniestro";
import { useMutation } from "@apollo/client";
import { UPDATE_MOVEMENTS } from "../../../services/siniestro";
import ModalContainer from "../../ModalContainer";

export const AgregarMovimientos = ({
  movementOpen,
  setMovementOpen,
  contract,
  shouldSubmit = false,
}) => {
  const { contractState } = useContract();
  const { siniesterState } = useSiniester();
  const [showNewMovement, setShowNewMovement] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const onCloseModal = () => setShowModal(false);
  const [notification, setNotification] = useState({
    show: false,
    created: false,
    customMessage: undefined,
  });
  const [movementsData, setMovementsData] = useState({
    reserva: 0,
    siniestro: 0,
    proveedores: 0,
    salvamento: 0,
    mxn: 0,
    usd: 0,
  });
  const [movimientos, setMovimientos] = useState(
    siniesterState?.movimientos || []
  );
  const onButton = () => {
    if (contract?.contrato_id)
      setMovementOpen((prev) => !prev);
  };
  const addPay = async (info) => {
    setShowModal(false);
    await setMovimientos((movement) => {
      const temp = movement;
      let movToEdit = movimientos[currentMovement];
      movToEdit = {
        ...movToEdit,
        estado: "parcial",
        pagos: info,
      };
      temp[currentMovement] = movToEdit;
      return temp;
    });
  };
  const onChangeInput = async (event) => {
    await setMovimientos((movement) => {
      const temp = movement;
      let movToEdit = movimientos[currentMovement];
      movToEdit = {
        ...movToEdit,
        [event.target.name]: event.target.value,
      };
      temp[currentMovement] = movToEdit;
      return temp;
    });
    calcMovements();
  };
  useEffect(() => {
    setCurrentMovement("");
    firstData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siniesterState?.movimientos]);

  const firstData = async () => {
    await setMovimientos(siniesterState?.movimientos || []);
    await calcMovements();
  };
  useEffect(() => {
    if (contract?.contrato_id && siniesterState?.siniestro_id) {
      setMovementOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract?.contrato_id]);
  const calcMovements = () => {
    let reserva = 0;
    let siniestro = 0;
    let proveedores = 0;
    let salvamento = 0;
    let mxn = 0;
    let usd = 0;

    movimientos?.forEach((item) => {
      const amount = Number(item.monto.split(",").join(""));
      switch (item.tipo) {
        case "Recuperaciones":
          item.moneda === "usd"
            ? (usd += Number(amount))
            : (mxn += Number(amount));
          break;

        case "Deducible":
        case "Coaseguro":
          reserva -= Number(amount);
          break;

        case "Anticipo":
        case "Indemnización":
          reserva -= Number(amount);
          siniestro += Number(amount);
          break;

        case "Salvamento":
          salvamento += Number(amount);
          break;

        case "Pago ajustadores":
        case "Pago expertos":
          proveedores += Number(amount);
          break;

        case "Alta reserva":
        case "Incremento reserva":
        case "Disminución reserva":
          reserva = Number(amount);
          siniestro = 0;
          proveedores = 0;
          salvamento = 0;
          mxn = 0;
          usd = 0;
          break;
        default:
          break;
      }
    });
    setMovementsData({
      reserva: reserva,
      siniestro: siniestro,
      proveedores: proveedores,
      salvamento: salvamento,
      mxn: mxn,
      usd: usd,
    });
  };
  const createNewMovement = async (tipo) => {
    let monto = "0.00";
    let estado = null;
    if (tipo === "Indemnización") monto = movementsData.reserva.toString();
    if (
      tipo === "Anticipo" ||
      tipo === "Indemnización" ||
      tipo === "Pago ajustadores" ||
      tipo === "Pago expertos"
    )
      estado = "registrar";
    let moneda = contractState?.valor_moneda || "MXN";
    const newMovement = {
      id: movimientos?.length + 1 || 0,
      tipo: tipo,
      fecha: Date.now(),
      monto,
      moneda,
      estado,
      registro: false,
      pagos: {
        Monto: "0.00",
      },
    };
    setMovimientos([...movimientos, newMovement]);
    setShowNewMovement(false);
  };
  useEffect(() => {
    calcMovements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movimientos]);
  const [currentMovement, setCurrentMovement] = useState("");
  const deleteMov = (id) => {
    const temp = movimientos;
    temp.splice(id, 1);
    setMovimientos(temp);
    calcMovements(temp);
  };

  const [updateMovements] = useMutation(UPDATE_MOVEMENTS, {
    onCompleted({ updateMovements }) {
      if (updateMovements.statusCode === 200) {
        const result = JSON.parse(updateMovements.response);
        setMovimientos(result);
      }
    },
    onError(err) {
      console.log("Error: ", err);
    },
  });

  const validateMovements = async () => {
    if (movimientos.length === 0) return 0;
    const movFilter = movimientos.filter((mov) => mov.estado === "registrar");
    if (movFilter.length > 0) {
      setNotification({
        show: true,
        created: false,
        customMessage: "Faltan movimientos por registrar",
      });
    }
    else {
      let movToJson = movimientos.map((mov, index) => {
        let estado =
          // eslint-disable-next-line
          mov.estado == "parcial" || mov.estado == "pagado" ? "pagado" : null;
        return {
          ...mov,
          estado,
          registro: true,
        };
      });
      const movimientosJSON = JSON.stringify(movToJson);
      await updateMovements({
        variables: {
          siniestro_id: siniesterState.siniestro_id,
          movimientos: movimientosJSON,
        },
      });
      return true;
    }
  };
  const refButton= useRef(null);
  const [forceClick, setForceClick] = useState(false);
  const prevalidate = () => {
    let shouldSubmit = false;
    movimientos.forEach((mov) => {
      if (mov.tipo === "Alta reserva" && mov.monto !== "0.00" && mov.monto !== "0" ) {
        shouldSubmit = true;
      }
    });
    if (shouldSubmit) setForceClick(true);
    else {
      setNotification({
        show: true,
        created: false,
        customMessage: "El campo alta reserva es obligatorio",
      });
    }
  };
  useEffect(() => {
    if (siniesterState?.siniestro_id) {
      validateMovements();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siniesterState?.siniestro_id]);
  return (
    <ModuleContainer open={movementOpen}>
       <ModalContainer
        showModal={notification.show}
        closeModal={() =>
          setNotification({
            show: false,
            created: false,
            customMessage: "",
          })
        }
      >
        <TextNotification created={notification.created}>
          {notification.created
            ? notification.customMessage || "Siniestro Agregado"
            : notification.customMessage || "Hubo un error, inténtelo de nuevo"}
        </TextNotification>
      </ModalContainer>
      <Modal
        open={showModal}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
        closeIcon={<CloseBlueIcon />}
        styles={{ background: "red" }}
      >
        <div style={{ padding: "12px 16px" }}>
          <ModuleTitle>Registro de Pago</ModuleTitle>
          <ModalRegistroPago
            addPay={addPay}
            info={movimientos?.length > 0 ? movimientos[currentMovement] : {}}
            movimientos={movimientos}
            currentMovement={currentMovement}
          />
        </div>
      </Modal>
      <Header
        onClick={() => {
          onButton();
        }}
      >
        <ModuleTitle>Agregar Movimientos</ModuleTitle>
        <ArrowDownIcon className="arrowMovs" />
      </Header>
      <Content className="content">
        <Divider />
        <TitleWraper>
          <ModuleTitle style={{ color: "var(--primary-royal-blue)" }}>
            Movimientos
          </ModuleTitle>
          <div style={{ position: "relative" }}>
            <MoreIcon
              negative
              onClick={() => setShowNewMovement((prev) => !prev)}
            />
            <ModalAgregarMovimiento
              showNewMovement={showNewMovement}
              setShowNewMovement={setShowNewMovement}
              createNewMovement={createNewMovement}
            />
          </div>
        </TitleWraper>
        <TableWrapper>
          <FiltersContainer>
            <FilterButton>#</FilterButton>
            <FilterButton>
              Tipo de Movimiento
              <ArrowDownIcon />
            </FilterButton>
            <FilterButton>Fecha</FilterButton>
            <FilterButton style={{ width: "120px" }}>Monto</FilterButton>
            <FilterButton>
              Moneda <ArrowDownIcon />
            </FilterButton>
          </FiltersContainer>
          <TableContainer>
            {movimientos?.length > 0 &&
              movimientos.map((item, index) => (
                <CardMovimientos
                  id={item.id}
                  type={item.tipo}
                  amount={item.monto}
                  date={item.fecha}
                  status={item.estado}
                  divisa={item.moneda.toString().toUpperCase()}
                  registro={item.registro}
                  key={item.id}
                  setShowModal={setShowModal}
                  onChangeInput={onChangeInput}
                  onDelete={() => {
                    deleteMov(index);
                  }}
                  onClick={() => {
                    setCurrentMovement(index);
                  }}
                />
              ))}
          </TableContainer>
        </TableWrapper>
        <Divider />
        <DataContainer>
          <DataText>
            <b>Reserva:</b> $
            {parseFloat(movementsData.reserva).toLocaleString("en")}
          </DataText>
          <DataText>
            <b>Salvamento:</b> $
            {parseFloat(movementsData.salvamento).toLocaleString("en")}
          </DataText>
          <DataText>
            <b>Pago de siniestro:</b> $
            {parseFloat(movementsData.siniestro).toLocaleString("en")}
          </DataText>
          <DataText>
            <b>Pago de proovedores:</b> $
            {parseFloat(movementsData.proveedores).toLocaleString("en")}
          </DataText>
          <DataText>
            <div>
              <span>
                <b>Recuperación (MXN):</b>{" "}
                {"$" + parseFloat(movementsData.mxn).toLocaleString("en")}
              </span>
              <span>
                <b>Recuperación (USD):</b>{" "}
                {"$" + parseFloat(movementsData.usd).toLocaleString("en")}
              </span>
            </div>
          </DataText>
        </DataContainer>
        {shouldSubmit === false || siniesterState?.siniestro_id ? (
          <Button
            text={"Confirmar movimientos"}
            style={{
              borderRadius: "20px",
              alignSelf: "flex-center",
              float: "right",
              marginTop: "40px",
            }}
            onClick={async () => {
             if(await validateMovements()){
              setNotification({
                show: true,
                created: true,
                customMessage: "Movimientos confirmados",
              });
             }

            }}
          />) : (
          <>
            <Button
              text={"Guardar Datos"}
              type="button"
              onClick={()=>{prevalidate()}}
              //readOnly={siniestroId !== ""}
              style={{
                borderRadius: "20px",
                alignSelf: "flex-center",
                float: "right",
                marginTop: "40px",
              }}
            />
            <Button
              text={"Guardar"}
              form="form-siniester"
              type="submit"
              innerRef={refButton}
              forceClick={forceClick}
              setForceClick={setForceClick}
              //readOnly={siniestroId !== ""}
              style={{
                borderRadius: "20px",
                alignSelf: "flex-center",
                float: "left",
                display: "none",
                marginTop: "40px",
              }}
            />
          </>
        )}
      </Content>
    </ModuleContainer>
  );
};
const TextNotification = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ created }) => (created ? "var(--primary-pistachio)" : "red")};
  margin: 0 20px;
`;
const ModuleContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
  margin-bottom: 30px;
  & > .content {
    display: ${(props) => (props.open ? "block" : "none")};
  }
  & .arrowMovs {
    transition: 500ms;
    transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0deg)")};
  }
  @media only screen and (max-width: 768px) {
    width: 90vw;
    padding: 40px 20px;
  }
  @media only screen (min-width: 769px) and (max-width: 1280px) {
    width: 100vw;
    padding: 40px 20px;
  }
`

const Header = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`;

const TitleWraper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div``;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 24px 0;
  background-color: var(--primary-pistachio);
`;

//==== TABLE ====//
const TableWrapper = styled.div`
  margin: 20px 0;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-bottom: 24px;
  @media only screen and (max-width: 768px) {
    overflow-x: scroll;
  } ;
`;

const TableContainer = styled.div`
  margin-top: 20px;
  display: grid;
  gap: 30px;
`;

const FiltersContainer = styled.div`
  display: flex;
  gap: 36px;
  margin-top: 30px;
  width: 1093px;
`;

const FilterButton = styled.div`
  /* cursor: pointer; */
  background: var(--secondary-alice-blue);
  border-radius: 8px;
  padding: 8px 21px;
  display: flex;
  justify-content: center;
  color: var(--primary-royal-blue);
  font-weight: 600;
  display: flex;
  gap: 10px;
  transition: 300ms;
  &:hover {
    /* opacity: 0.8; */
  }
`;

//==== DATA ====//
const DataContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 36px;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    gap: 12px;
    & span b {
      width: 100%;
      text-align: left !important;
    }
  } ;
`;

const DataText = styled.span`
  background: var(--secondary-alice-blue);
  color: var(--primary-royal-blue);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  justify-content: center;
  font-weight: 600;
  display: flex;
  gap: 10px;
  transition: 300ms;
  & > div {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  @media only screen and (max-width: 1024px) {
    width: 100%;
  } ;
`;
